import React from 'react';
const modules = [{
  number: 1,
  title: 'Rentabilidad y Pre-Venta',
  description: 'Aprendé a calcular costos al centavo (sin miedo a la inflación) y lanzá tu oferta validada para',
  bold: 'vender antes de gastar',
  suffix: '.'
}, {
  number: 2,
  title: 'Producción Inteligente',
  description: 'Dejá de ser esclava de la cocina. Dominá el',
  bold: 'Batch Cooking Profesional',
  suffix: ': producí 50 viandas en el tiempo que hacés 5.'
}, {
  number: 3,
  title: 'Logística y Seguridad',
  description: 'Bromatología simplificada, conservación perfecta y delivery estratégico. Tu negocio, 100% profesional y seguro.',
  bold: '',
  suffix: ''
}, {
  number: 4,
  title: 'Escala y Automatización',
  description: 'Sistemas para que los clientes vuelvan solos. Creación de marca, fidelización y',
  bold: 'cómo delegar para crecer sin límites',
  suffix: '.'
}];
export function ModulesSection() {
  return <section className="w-full bg-[#f9f8f4] px-4 md:px-8 pt-4 pb-16" data-id="element-218">
      <div className="max-w-[900px] mx-auto space-y-6" data-id="element-219">
        {modules.map(mod => <div key={mod.number} className="bg-white rounded-2xl shadow-[0_2px_12px_rgba(0,0,0,0.06)] overflow-hidden transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_8px_24px_rgba(0,0,0,0.1)] cursor-default" data-id="element-220">
            {/* Header */}
            <div className="bg-[#e8f5e2] px-6 md:px-8 py-4 flex items-center gap-4" data-id="element-221">
              <span className="bg-[#4caf50] text-white font-['Montserrat',_sans-serif] font-bold text-xs md:text-sm uppercase tracking-wider px-4 py-1.5 rounded-full" data-id="element-222">
                Módulo {mod.number}
              </span>
              <h3 className="font-['Playfair_Display',_serif] text-xl md:text-2xl font-bold text-[#1a1a1a]" data-id="element-223">
                {mod.title}
              </h3>
            </div>

            {/* Body */}
            <div className="px-6 md:px-8 py-5" data-id="element-224">
              <p className="font-['Montserrat',_sans-serif] text-[#374151] text-base md:text-lg leading-relaxed" data-id="element-225">
                {mod.bold ? <>
                    {mod.description}{' '}
                    <span className="font-bold text-[#1a1a1a]" data-id="element-226">{mod.bold}</span>
                    {mod.suffix}
                  </> : mod.description}
              </p>
            </div>
          </div>)}
      </div>
    </section>;
}